import { SHFilterOption } from "@components/design-systems";
import { SupplierStatus } from "@models/supplier/enums/status";
import { lastDayOfYear } from "date-fns";
import { template } from "lodash";

export const StatusSuppliersFilterOptions: SHFilterOption[] = [
  {
    label: "Active",
    value: SupplierStatus.Active,
  },
  {
    label: "Disabled",
    value: SupplierStatus.Disabled,
  },
  {
    label: "Archived",
    value: SupplierStatus.Archived,
  },
];
export const DefaultSuppliersStatusFilterValue = [
  SupplierStatus.Active,
  SupplierStatus.Disabled,
];

export enum AdditionalVisualizeTable {
  INVESTMENT_APPROACH = "Investment approach",
  ASSET_ALLOCATION_NOTES = "Asset allocation notes",
  ASSET_ALLOCATION = "Asset allocation",
  RISK_MEASURES = "Risk measures",
}

export enum InvestmentFeatureHiddenInViewMode {
  TARGET_EXISTS = "Model has an AA target",
}

export const SubColumnNames = ["Net capital gains (% p.a.)", "Income (% p.a.)"];

export const SpecialSection = [
  "Service offering",
  "Reporting and communications",
];

/**
 * @description Use for edit model field dependence on another field
 * Target growth exposure = 100 - Target defensive exposure
 * Passive Share  = 100 - Active Share
 */

export enum DependedFeature {
  TARGET_GROWTH_EXPOSURE = "Target growth exposure",
  TARGET_DEFENSIVE_EXPOSURE = "Target defensive exposure",
  ACTIVE_SHARE = "Active Share",
  PASSIVE_SHARE = "Passive Share",
}

export enum VisibilityMessage {
  FEATURE_LEVEL = "Restricted view - The manager has not shared this data with your firm",
  PRODUCT_LEVEL = "Limit the visibility of your entire profile",
  SERIES_LEVEL = "Limit visibility of series",
  HAS_CUSTOM_VISIBILITY = "Visibility limited to certain user groups",
}

export enum IconMessage {
  IMAP_FEATURE_AWARD = "This field must be completed if participating in the IMAP awards",
}

export enum InvestmentProductCalculationSectionStaticId {
  PortfolioReturns = "IC_SEC_0005",
  RiskMeasures = "IC_SEC_0006",
  OtherDetails = "IC_SEC_0007",
  PortfoliPeriodDate = "IC_FEA_0014",
  TotalNetReturn = "IC_FEA_0015",
  NetCapitalGains = "IC_FEA_0016",
  Income = "IC_FEA_0017",
  BenchmarkReturn = "IC_FEA_0018",
  TotalNetExcessReturn = "IC_FEA_0019",
  RiskPeriodDate = "IC_FEA_0020",
  StandardDeviation = "IC_FEA_0021",
  SharpeRatio = "IC_FEA_0022",
  InformationRatio = "IC_FEA_0023",
  Beta = "IC_FEA_0024",
  DrawdownRatio = "IC_FEA_0025",
  CalmarRatio = "IC_FEA_0026",
  NominatedPlatform = "IC_FEA_0027",
  Disclaimer = "IC_FEA_0028",
  Other = "IC_FEA_0033",
}

export enum InvestmentProductCalculationSectionTooltip {
  BrokenLinkMessage = "Uploaded performance data not in use as data has been entered manually",
}

export enum InvestmentProductModelDefaultFileName {
  DEFAULT_PERFORMANCE_TEMPLATE_NAME = "Managed+Accounts+Performance+Template+-+SuitabilityHub.xlsx",
}

export const PerformanceFileNameTemplate = template(
  "SH return series - <%= data.managerName %> <%= data.seriesName %> <%= data.modelName %> <%= data.date %>.xlsx",
  {
    variable: "data",
  },
);

export const DateRangeLimits = {
  minDate: new Date("2000-01-01"),
  maxDate: lastDayOfYear(new Date())
};

export enum InvestmentProductSeriesStaticId {
  SectionResponsibleInvestmentPractices = "IC_SEC_0010",
  FeatureRoleOfESG = "IC_FEA_0034",
  FeatureESGObjectives = "IC_FEA_0035",
  FeatureInvestmentManagerIncentivesTied = "IC_FEA_0036"
}

export const SeriesDependedFeatureStaticId = [
    "IC_FEA_0035",
    "IC_FEA_0036"
]

export class SpecialSectionNames {
  static readonly BTPanoramaAlternateAdminFeesFamilyGroups: string =
    "Alternate admin fees for family groups (BT Panorama approach)";

  static readonly FamilyFeeAggregation: string = "Family fee aggregation";

  static readonly SectionNamesToHide: string[] = [
    this.BTPanoramaAlternateAdminFeesFamilyGroups,
  ];
}